import { FC } from 'react';

import styled from '@emotion/styled';
import { generatePath, useNavigate } from 'react-router-dom';
import { ROUTES } from 'core';

import { BcAlert } from '@britishcouncil/react-solas-ors3';
import { Button } from '@britishcouncil/react-solas';

export const PaymentError: FC<{ referenceNumber: string }> = ({
  referenceNumber,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <BcAlert title="Payment unsuccessful" type="danger">
        <p>
          There was an error processing your payment. Please try payment again.
        </p>
      </BcAlert>

      <StyledH3>What would you like to do?</StyledH3>

      <Button intent="success" onClick={() => navigate(generatePath(ROUTES.SELECT_PAYMENT, { referenceNumber }))}>
        Pay another way
      </Button>
    </>
  );
};

const StyledH3 = styled.h3`
  margin-top: 20px;
`;
